// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"80":"3b9e7820","208":"e2f3ef13","584":"14e1449d"}[chunkId] + ".css";
};